module.exports = __webpack_public_path__ + "static/media/image-card-5.b1eae784.png";